module.exports = __webpack_public_path__ + "img/ep-V.63819118.jpg";